import { render } from "./UsuarioModal.vue?vue&type=template&id=5a1c51a0&scoped=true&ts=true"
import script from "./UsuarioModal.vue?vue&type=script&lang=ts"
export * from "./UsuarioModal.vue?vue&type=script&lang=ts"

import "./UsuarioModal.vue?vue&type=style&index=0&id=5a1c51a0&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1c51a0"]])

export default __exports__